import { useEffect, useState } from 'react'
import subsidiariesApi from 'services/api/subsidiaries'

const minPromoCodeCountToShowWarning = 20
const maxPromoCodeCountToShowWarning = 50

function usePromoValidation(promoCode) {
  const [isWarningByPassed, setIsWarningByPassed] = useState(false)

  const [messageType, setMessageType] = useState(false)

  useEffect(() => {
    setIsWarningByPassed(false)
    setMessageType(null)
  }, [promoCode])

  async function checkRateCodeUsage(promoCode) {
    const res = await subsidiariesApi.rateCodeUsage(promoCode)

    const { untilTodayBooking } = res

    if (
      minPromoCodeCountToShowWarning < untilTodayBooking &&
      untilTodayBooking <= maxPromoCodeCountToShowWarning
    ) {
      setMessageType('soft')
      return { messageType: 'soft' }
    } else if (untilTodayBooking > maxPromoCodeCountToShowWarning) {
      setMessageType('hard')
      return { messageType: 'hard' }
    } else {
      setMessageType(null)
      return { messageType: null }
    }
  }

  return {
    isWarningByPassed,
    setIsWarningByPassed,
    messageType,
    checkRateCodeUsage
  }
}

export default usePromoValidation
